import { ProductSwitchRecordDto } from '@eneco/dc-be/client';

type GTMPayload = {
  currentActiveTechnicalProductName?: string;
  energyType?: string;
  selectedTechnicalProductName?: string;
  stepIndex: number;
  isSummary: boolean;
};

export const buildGTMNextButtonPayload = ({
  activeProduct,
  selectedProductsSwitchNames,
  activeIndexProductSwitch,
  CURRENT,
}: {
  activeProduct?: ProductSwitchRecordDto;
  selectedProductsSwitchNames: string[];
  activeIndexProductSwitch: number;
  CURRENT: string;
}): GTMPayload => {
  const selectedSwitchName = selectedProductsSwitchNames[activeIndexProductSwitch];

  const currentName = activeProduct?.current?.technicalProductName ?? '';
  const energyType = activeProduct?.current?.energyType;

  if (selectedSwitchName === CURRENT) {
    return {
      currentActiveTechnicalProductName: currentName,
      energyType,
      selectedTechnicalProductName: currentName,
      stepIndex: activeIndexProductSwitch,
      isSummary: false,
    };
  }

  const selectedName = activeProduct?.switchOptions?.find(
    so => so.technicalProductName === selectedSwitchName,
  )?.technicalProductName;

  return {
    currentActiveTechnicalProductName: currentName,
    energyType,
    selectedTechnicalProductName: selectedName ?? '',
    stepIndex: activeIndexProductSwitch,
    isSummary: false,
  };
};

export const buildGTMSummaryButtonPayload = ({
  productSwitchNames,
  sortedProducts,
  CURRENT,
}: {
  productSwitchNames: string[];
  sortedProducts: ProductSwitchRecordDto[];
  CURRENT: string;
}): Array<Partial<GTMPayload>> => {
  return productSwitchNames.map((switchName, index) => {
    const result = {
      currentActiveTechnicalProductName: sortedProducts?.[index]?.current?.technicalProductName ?? '',
      energyType: sortedProducts?.[index]?.current?.energyType,
      selectedTechnicalProductName: sortedProducts?.[index]?.current?.technicalProductName ?? '',
      isSummary: true,
    };
    if (switchName === CURRENT) return result;

    return {
      ...result,
      selectedTechnicalProductName:
        sortedProducts?.[index]?.switchOptions?.find(so => so.technicalProductName === switchName)
          ?.technicalProductName ?? '',
    };
  });
};
